import styled from "styled-components";

import Cell from "components/Cell";

export default styled(Cell)`
  cursor: pointer;
`;
